import React, { useEffect, useState } from 'react';
import { Row, Spin, Breadcrumb } from 'antd';
import ImageCard from '../../../components/ImageWithLabel'
import { categoryListTree } from '../../../services/categoryApi';
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from '../../../components/CategoryBreadcrumbs';


const Categories: React.FC = () => {
  const [categories, setCategories] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);


  let navigate = useNavigate();
  let { id = 0 } = useParams();
  useEffect(() => {
    setIsLoading(true);
    categoryListTree().then(result => {
      setCategories(result);
      setIsLoading(false);
    });
  }, [id]);
  const handleClick = (categId: number) => {
    navigate('/learning/materials/' + categId)
  }
  return (
    <Spin spinning={isLoading}>
      <Breadcrumbs id={id} />
      <Row gutter={[16, 16]}>
        {categories.map((item: any) => (
          <ImageCard src={'/api/public/categories/' + item.imgSource} label={item.name} key={item.id} onClick={() => handleClick(item.id)}> </ImageCard>
        ))}
      </Row>
    </Spin >
  );
};

export default Categories;
